/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'button/swiper-arrow': {
    width: 9,
    height: 17,
    viewBox: '0 0 9 17',
    data: '<path pid="0" d="M1 16l6-7.5L1 1" _stroke="currentColor" stroke-width="2"/>'
  }
})
